// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const UploadButton = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.uploadButton"
        description="Upload button."
        defaultMessage="Save as Draft"
    />
);
UploadButton.displayName = "UploadButton";

export const UploadAndPublishButton = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.uploadAndPublishButton"
        description="Upload and publish button."
        defaultMessage="Publish"
    />
);
UploadAndPublishButton.displayName = "UploadAndPublishButton";

export const UpdatePublishedLensButton = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.updatePublishedLensButton"
        description="Update published lens button."
        defaultMessage="Submit for Review"
    />
);
UpdatePublishedLensButton.displayName = "UpdatePublishedLensButton";

export const UpdateFolderLensButton = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.updateFolderLensButton"
        description="Update folder lens button."
        defaultMessage="Save as Draft"
    />
);
UpdateFolderLensButton.displayName = "UpdateFolderLensButton";

export const MonetizationDisabledMessage = (props: { conflictingOption: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.monetizationDisabledMessage"
        description="Monetization disabled message."
        defaultMessage="Disabled because {conflictingOption} is selected. Only one monetization option can be active."
        values={props}
    />
);
MonetizationDisabledMessage.displayName = "MonetizationDisabledMessage";

export const LensCreatorRewardsOption = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.lensCreatorRewardsOption"
        description="Lens creator rewards option."
        defaultMessage="Top Performer Payouts"
    />
);
LensCreatorRewardsOption.displayName = "LensCreatorRewardsOption";

export const LensPlusPilotProgramOption = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.lensPlusPilotProgramOption"
        description="Lens plus pilot program option."
        defaultMessage="Lens+ Payouts"
    />
);
LensPlusPilotProgramOption.displayName = "LensPlusPilotProgramOption";

export const ApplyText = (): ReactElement => (
    <FormattedMessage id="apps.submit.components.shared.applyText" description="Apply text." defaultMessage="Apply" />
);
ApplyText.displayName = "ApplyText";

export const TosWarningTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.tosWarningTitle"
        description="Tos warning title."
        defaultMessage="You must accept the terms to continue"
    />
);
TosWarningTitle.displayName = "TosWarningTitle";

export const TosWarningContent = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.tosWarningContent"
        description="Tos warning content."
        defaultMessage="To enable monetization for your Lens, please review and accept the terms for each payout program."
    />
);
TosWarningContent.displayName = "TosWarningContent";

export const ViewTerms = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.viewTerms"
        description="View terms."
        defaultMessage="View Terms"
    />
);
ViewTerms.displayName = "ViewTerms";

export const AiClipsLensInfo = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.shared.aiClipsLensInfo"
        description="Ai clips lens info."
        defaultMessage="This Lens will be made available to Lens+ subscribers"
    />
);
AiClipsLensInfo.displayName = "AiClipsLensInfo";
